/**
 * Case Studies Intro Block JavaScript
 * Videos with data-viewport-play: play when block in view, pause when out
 */

(function() {
    'use strict';

    function initViewportVideos(block) {
        const videos = block.querySelectorAll('video[data-viewport-play]');
        if (!videos.length) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const video = entry.target;
                if (entry.isIntersecting) {
                    video.play().catch(() => {});
                } else {
                    video.pause();
                }
            });
        }, { rootMargin: '50px', threshold: 0.1 });

        videos.forEach(video => observer.observe(video));
    }

    function initCaseStudiesIntro() {
        const blocks = document.querySelectorAll('.case-studies-intro');
        blocks.forEach(block => initViewportVideos(block));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCaseStudiesIntro);
    } else {
        initCaseStudiesIntro();
    }
})();